import { ActivityDto } from '@maia/shared';
import {
  Divider,
  MarkdownRenderer,
  SideDrawer,
  SidedrawerProps,
  Spec,
  SpecList,
  Typography,
} from '@maia/ui';
import { useDrawerStore } from '../../../stores/drawer.store';
import { mapper } from '@maia/icons';
import { formatDate } from '@maia/utils';

type Props = {
  activity?: ActivityDto;
} & Pick<SidedrawerProps, 'onOpenChange' | 'portalRef'>;

export function ActivitySidedrawer(props: Props) {
  const { activity, ...rest } = props;
  const { state, closeDrawer } = useDrawerStore();

  return (
    <SideDrawer
      {...rest}
      title="Bekijk activiteit"
      className="w-full pb-32 max-w-[var(--max-side-drawer-width)]"
      isOpen={state?.isOpen && state.info?.type === 'activity'}
      onOpenChange={closeDrawer}
    >
      {state?.info?.type === 'activity' ? (
        <div className="flex flex-col mt-32 gap-y-32">
          <div className="flex flex-col">
            {mapper(state?.info.data.icon)}

            <Typography
              variant="body-s"
              weight="medium"
              className="text-grayscale600 mt-12"
            >
              {state?.info.data.title}
            </Typography>

            <SpecList className="mt-12">
              <Spec
                className="grid grid-cols-2"
                title="Aangemaakt op"
                value={formatDate(state?.info.data.date)}
              />
            </SpecList>
          </div>

          <Divider />

          <div className="overflow-y-auto max-h-[300px]">
            <MarkdownRenderer markdown={state?.info.data?.message} />
          </div>
        </div>
      ) : null}
    </SideDrawer>
  );
}
